import decode from 'jwt-decode'
import Auth from './Auth'
import assets from './crudFunctions/assets'

const checkAccess = async (): Promise<string | undefined> => {
  if (Auth()) {
    const access: string = localStorage.getItem('access')!
    const refresh: string = localStorage.getItem('refresh')!
    const url: string = assets.apiUrl + 'token/refresh/'
    const body: string = JSON.stringify({ refresh: refresh })
    const headers: RequestInit = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'content-type': 'application/json'
      },
      body: body
    }

    try {
      // { exp: 121325664189 }
      const { exp }: { exp: number } = decode(access)
      const timeMargin: number = 15
      const currentTime: number = new Date().getTime() / 1000 + timeMargin

      if (exp < currentTime) {
        // exp is going to expire in 15 seg
        const newAccess: Response = await fetch(url, headers)
        const response: { access: string } = await newAccess.json()
        localStorage.setItem('access', response.access)
        return response.access
      } else {
        return access
      }
    } catch (error) {
      return access
    }
  } else {
    window.location.replace('/admin/login')
  }
}

export default checkAccess
